import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowCTA',
  props: {
    isHighlighted: { type: Boolean },
    showPromoBanner: { type: Boolean }
  },
  setup(__props: any) {



const { tc } = useI18n();

return { __sfc: true,tc }
}

})